import { RedoShopifyCountryCode } from "@redotech/redo-model/fulfillments/fulfillment-country-code";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getReturnBearCountries = {
  name: "getReturnBearCountries" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    countries: z.array(
      createEnum(RedoShopifyCountryCode, {
        enumName: "RedoShopifyCountryCode",
      }),
    ),
  }),
};
